import { UserService } from '../../_api/services'
import AuhtService from '../../_api/auth.service'
import JwtService from '../../_helpers/jwt.service'
import {
  LOGIN,
  LOGOUT,
  SIGNUP,
  UPDATE_USER,
  REFRESH_USER,
  FORGOTPASSWORD,
  UPDATE_USERSETTINGS
} from '../actions.type'
import { SET_AUTH, PURGE_AUTH } from '../mutations.type'

const state = {
  user: JwtService.getUserData() || {},
  isAuthenticated: !!JwtService.getToken(),
  role: {}
}

const getters = {
  currentUser (currentState) {
    return currentState.user
  },
  isAuthenticated (currentState) {
    return currentState.isAuthenticated
  },
  role (currentState) {
    const authRole = {}
    if (!currentState.user) return authRole
    const roles = currentState.user.roles ? currentState.user.roles.split(',') : []
    const permissions = currentState.user.permissions
      ? currentState.user.permissions.split(',')
      : []
    if (roles.includes('limited')) {
      authRole.limited = true
    } else if (roles.includes('company')) {
      authRole.company = true
      if (permissions.length > 0) {
        if (permissions.includes('processCreate')) {
          authRole.companyProcessCreate = true
        }
        if (permissions.includes('subCompanyManagement')) {
          authRole.companyManagement = true
        }
        if (permissions.includes('subCompanySeeDefaultProcesses')) {
          authRole.companyDefaultProcess = true
        }
        if (permissions.includes('processWithPoint')) {
          authRole.processWithPoint = true
          authRole.companyDepartmentManagement = true
        }
      }
    } else if (
      currentState.user.parentCompanyId &&
      permissions.includes('subCompanySeeDefaultProcesses')
    ) {
      authRole.companyDefaultProcess = true
    } else if (roles.includes('admin')) {
      authRole.admin = true
      authRole.company = true
      authRole.companyProcessCreate = true
      authRole.companyManagement = true
      authRole.companyDefaultProcess = true
      authRole.processWithPoint = true
      authRole.companyDepartmentManagement = true
    }
    return authRole
  }
}

const actions = {
  [LOGIN] (context, credentials) {
    return AuhtService.login(credentials).then(response => {
      context.commit(SET_AUTH, response)
      return response
    })
  },
  [LOGOUT] (context) {
    context.commit(PURGE_AUTH)
  },
  [SIGNUP] (context, credentials) {
    return AuhtService.signup(credentials)
  },
  [FORGOTPASSWORD] (context, credentials) {
    return AuhtService.forgotPassword(credentials)
  },
  [UPDATE_USER] (context, user) {
    return UserService.update(user).then(data => {
      context.commit(SET_AUTH, { data })
      return data
    })
  },
  [REFRESH_USER] (context) {
    return UserService.getCurrent().then(response => {
      context.commit(SET_AUTH, response)
      return response
    })
  },
  [UPDATE_USERSETTINGS] (context, userSettings) {
    return UserService.updateUserSettings(userSettings).then(data => {
      const userData = JwtService.getUserData()
      userData.userSettings = userSettings
      context.commit(SET_AUTH, { data: userData })
      return data
    })
  }
}

const mutations = {
  [SET_AUTH] (currentState, user) {
    const newState = currentState
    newState.isAuthenticated = true
    newState.user = user.data
    JwtService.saveAuthData(user.token, user.data)
  },
  [PURGE_AUTH] (currentState) {
    const newState = currentState
    newState.isAuthenticated = false
    newState.user = {}
    JwtService.destroyAuthData()
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
